/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventStarterPackInfoUpdateRequest model module.
 * @module model/EventsControllerDtoEventStarterPackInfoUpdateRequest
 * @version 1.0
 */
class EventsControllerDtoEventStarterPackInfoUpdateRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventStarterPackInfoUpdateRequest</code>.
     * @alias module:model/EventsControllerDtoEventStarterPackInfoUpdateRequest
     */
    constructor() { 
        
        EventsControllerDtoEventStarterPackInfoUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventStarterPackInfoUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventStarterPackInfoUpdateRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventStarterPackInfoUpdateRequest} The populated <code>EventsControllerDtoEventStarterPackInfoUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventStarterPackInfoUpdateRequest();

            if (data.hasOwnProperty('packNo')) {
                obj['packNo'] = ApiClient.convertToType(data['packNo'], 'Number');
            }
            if (data.hasOwnProperty('regDuration')) {
                obj['regDuration'] = ApiClient.convertToType(data['regDuration'], 'Number');
            }
            if (data.hasOwnProperty('needUsedPower')) {
                obj['needUsedPower'] = ApiClient.convertToType(data['needUsedPower'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('rewardXper')) {
                obj['rewardXper'] = ApiClient.convertToType(data['rewardXper'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem1')) {
                obj['rewardItem1'] = ApiClient.convertToType(data['rewardItem1'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem1Count')) {
                obj['rewardItem1Count'] = ApiClient.convertToType(data['rewardItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem2')) {
                obj['rewardItem2'] = ApiClient.convertToType(data['rewardItem2'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem2Count')) {
                obj['rewardItem2Count'] = ApiClient.convertToType(data['rewardItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem3')) {
                obj['rewardItem3'] = ApiClient.convertToType(data['rewardItem3'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem3Count')) {
                obj['rewardItem3Count'] = ApiClient.convertToType(data['rewardItem3Count'], 'Number');
            }
            if (data.hasOwnProperty('initialXper')) {
                obj['initialXper'] = ApiClient.convertToType(data['initialXper'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventStarterPackInfoUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventStarterPackInfoUpdateRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} packNo
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['packNo'] = undefined;

/**
 * @member {Number} regDuration
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['regDuration'] = undefined;

/**
 * @member {Number} needUsedPower
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['needUsedPower'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['endAt'] = undefined;

/**
 * @member {Number} rewardXper
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['rewardXper'] = undefined;

/**
 * @member {Number} rewardItem1
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['rewardItem1'] = undefined;

/**
 * @member {Number} rewardItem1Count
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['rewardItem1Count'] = undefined;

/**
 * @member {Number} rewardItem2
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['rewardItem2'] = undefined;

/**
 * @member {Number} rewardItem2Count
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['rewardItem2Count'] = undefined;

/**
 * @member {Number} rewardItem3
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['rewardItem3'] = undefined;

/**
 * @member {Number} rewardItem3Count
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['rewardItem3Count'] = undefined;

/**
 * @member {Number} initialXper
 */
EventsControllerDtoEventStarterPackInfoUpdateRequest.prototype['initialXper'] = undefined;






export default EventsControllerDtoEventStarterPackInfoUpdateRequest;

